import React, { useState, useEffect, useContext } from 'react'
import { Selected } from '../../../context/context'
import { calculateLogoPrice } from '../../../utils/utils'
import Details from './Details'
// import ContactDetails from './Contact'
import CountAnimation from './Counter'
import ContactoWhats from './Whats'
import {
    Content,
    Title,
    DetallesContainer,
    Counter,
    Note,
    CounterContainer,
} from './Elements'
import {
    motionTitle,
} from './Motion'

const Presupuesto = () => {

    const [selected, setSelected] = useContext(Selected)
    const [total, setTotal] = useState(0)

    const handleSetTotal = () => {

        const logoPrice = calculateLogoPrice(selected)
        setTotal(logoPrice + selected.precioUnidad)

    }

    useEffect(() => {
        handleSetTotal()
    }, [])

    useEffect(() => {
        setSelected({
            ...selected,
            total: total
        })
    }, [total])

    return(
        <Content variants={motionTitle}
        initial="initial"
        animate="animate"
        exit="exit">
                <Title
                variants={motionTitle}
                initial="initial"
                animate="animate"
                exit="exit"
                >
                    Presupuesto
                </Title>
                <DetallesContainer>
                    <CounterContainer>
                        <Counter>
                        $
                        {
                            total !== 0 && 
                            <CountAnimation>{total}</CountAnimation>
                        }
                        </Counter>
                        <Note>(precio por unidad)</Note>
                    </CounterContainer>
                    <Details selected={selected}/>
                </DetallesContainer>
                <ContactoWhats />
                {/* <ContactDetails selected={selected}/> */}
        </Content>
    )
}

export default Presupuesto